import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { FacilityService } from 'src/app/services/facility.service';
import { CompanyService } from 'src/app/services/Modules/company.service';
import { UserService } from 'src/app/services/Modules/user.service';
import { USER_TYPE } from '../global';
import swal from 'sweetalert';

@Component({
    selector: 'app-provider-facility-association',
    templateUrl: './provider-facility-association.component.html',
    styleUrls: ['./provider-facility-association.component.css']
})
export class ProviderFacilityAssociationComponent implements OnInit {
    public response: any;
    public dataSource: any;
    public facilities: any = [];
    providers: any = [];
    providersName: any = [];
    selectedProviders: any = [];
    providerTranscriber: Boolean = true;
    providerBiller: Boolean = false;
    providerDropdownSettings: any = {};
    templateDropdownSettings: any = {};
    companySide: Boolean = false;

    displayedColumns: string[] = ['facility', 'provider'];
    @ViewChild(MatSort) sort: MatSort;

    params: {
        id: string
    }
    filterStatus = true;
    loaderId = 'facility-provider-association-loader';

    // pagination = {
    //     pageNo: 1,
    //     hasNextPage: false,
    //     hasPrevPage: false,
    //     totalFacilities: 0,
    //     totalPages: 0,
    //     currentRecords: 0
    // };
    pagination = {
        pageNo: 1,
        hasNextPage: false,
        hasPrevPage: false,
        totalRecords: 0,
        PAGE_LIMIT: 20,
        skip: 0
    };
    facilityTitleRegExp = "";
    providerTitleRegExp = "";
    PAGE_LIMIT = 20;
    timeoutId: any;
    hasFacilitiesLoaded: boolean = false;
    hasProvidersLoaded: boolean = false;
    showProviderPaginations: boolean = false;

    constructor(
        public companyService: CompanyService,
        private route: ActivatedRoute,
        private toastr: ToastrService,
        private loader: NgxUiLoaderService,
        private facilityService: FacilityService,
        private userService: UserService,
        private router: Router
    ) {
        this.providerDropdownSettings = {
            singleSelection: false,
            idField: '_id',
            textField: 'full_name',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            itemsShowLimit: 10,
            allowSearchFilter: true,
            enableCheckAll: true,
        };
        this.templateDropdownSettings = {
            singleSelection: false,
            idField: '_id',
            textField: 'title',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            itemsShowLimit: 10,
            allowSearchFilter: true,
            enableCheckAll: true,
        };
        if (window.location.pathname.includes('company')) {
            this.companySide = true
            this.params = {
                id: this.route.parent.snapshot.params.id
            };
        }
        else {
            this.companySide = false
            this.params = {
                id: ''
            };
        }
    }

    async ngOnInit() {
        this.loader.startLoader(this.loaderId);
        await this.initProviders();
        //   await this.initFacilities();
        await this.initAssociationData()
        // if (this.facilities.length > 1) {
        //     this.updatePageCountForFirstPage();
        // }
        this.loader.stopLoader(this.loaderId);
    }
    searchFacilities() {
        clearTimeout(this.timeoutId);
        this.timeoutId = setTimeout(() => {
            this.hasFacilitiesLoaded = true;
            this.initAssociationData();
        }, 1000);
    }
    searchProviders() {
        clearTimeout(this.timeoutId);
        this.timeoutId = setTimeout(() => {
            this.hasProvidersLoaded = true;
            this.initAssociationData();
        }, 1000);
    }
    applyActiveFilter(event) {
        this.filterStatus = event.value;
        this.pagination.pageNo = 1;
        this.initAssociationData();
    }
    async initAssociationData() {
        this.loader.startLoader(this.loaderId);
        const company_id = this.params.id;

        const filter: any = {
            //is_active: null,
            is_active: this.filterStatus,
            company_id,
            pageNo: this.pagination.pageNo
        };
        if (this.facilityTitleRegExp !== "") {
            filter.title = this.facilityTitleRegExp;
            delete filter.pageNo;
        }
        if (this.providerTitleRegExp !== "") {
            filter.providerTitle = this.providerTitleRegExp;
            delete filter.pageNo;
        }
        const projection = {
            'title': 1,
            'address': 1,
            'city': 1,
            'state': 1,
            'zip_code': 1,
            'provider_ids_ref': 1,
            'template_ids_ref': 1
        }
        let result: any = await this.facilityService.getAllFacilitiesProviderTemplateAssoc(filter, projection).toPromise();
        if (result.status == 200) {
            this.pagination.totalRecords = result.data.totalFacilities;
            // this.pagination.currentRecords = result.data.facilities.length;

            let data = JSON.parse(JSON.stringify(result.data));
            data = result.data.facilities.map(ele => {
                ele.allTemp.map(temp => {
                    temp.title = temp.title.toUpperCase();
                    return temp;
                });
                return ele;
            });
            
            this.facilities = data;
            this.facilities.map(facility => {
                facility.providersDropDown = this.providers;
            });
            if(this.facilityTitleRegExp !== "" || this.providerTitleRegExp !== "") {
                // this.pagination.totalRecords = result.data.totalFacilities;
                this.pagination.hasNextPage = false;
                this.pagination.hasPrevPage = false;
                this.pagination.skip = 0;
            }
            if(this.facilityTitleRegExp == "" && this.providerTitleRegExp == "") {
                this.handlePagination();
            }
            // if (filter.title) {
            //     this.pagination.hasNextPage = false;
            //     this.pagination.hasPrevPage = false;
            // }
            // else if (filter.providerTitle) {
            //     this.pagination.hasNextPage = false;
            //     this.pagination.hasPrevPage = false;

            // }
            // else if (filter.pageNo) {
            //     this.updatePageCountForFirstPage();
            // }
            this.dataSource = new MatTableDataSource(this.facilities);
            this.loader.stopLoader(this.loaderId);
            this.hasFacilitiesLoaded = false;
            this.hasProvidersLoaded = false;
        }
        else if (result.status == 403) {
            this.toastr.error(result.message, "ERROR");
            this.router.navigate(['/403']);
        }
    }

    handlePagination() {
        this.pagination.skip = (this.pagination.pageNo - 1) * this.pagination.PAGE_LIMIT;
        if (this.pagination.skip + this.facilities.length < this.pagination.totalRecords) {
          this.pagination.hasNextPage = true;
        }
        else {
          this.pagination.hasNextPage = false;
        }
        if (this.pagination.skip > 0) {
          this.pagination.hasPrevPage = true;
        }
        else {
          this.pagination.hasPrevPage = false;
        }
        
      }


    // updatePageCountForFirstPage() {
    //     if (this.pagination.currentRecords < this.pagination.totalFacilities) {
    //         this.pagination.hasNextPage = true;
    //         this.pagination.currentRecords = (this.pagination.pageNo - 1) * this.PAGE_LIMIT + this.facilities.length;
    //     }
    // }

    initFacilities = async () => {
        const company_id = this.params.id;
        const filter = {
            is_active: this.filterStatus,
            company_id
        }
        const projection = {
            'title': 1,
            'address': 1,
            'city': 1,
            'state': 1,
            'zip_code': 1,
            'provider_ids_ref': 1,
        }
        const facilitiesResponse: any = await this.facilityService.getAllFacilities(filter, projection).toPromise();
        if (facilitiesResponse.status === 200) {
            this.facilities = facilitiesResponse.data.array;
            for (const facility of this.facilities) {
                facility.provider_ids_ref = facility.provider_ids_ref
                    .filter((facilityProvider) => {
                        if (typeof facilityProvider === 'string') {
                            return this.providers.find(provider => provider._id === facilityProvider);
                        }
                        return true;
                    }).map((facilityProvider) => {
                        if (typeof facilityProvider === 'string') {
                            return this.providers.find(provider => provider._id === facilityProvider);
                        } else {
                            return facilityProvider;
                        }
                    })

            }
            this.dataSource = new MatTableDataSource(this.facilities);
        }
    }

    initProviders = async () => {
        const company_id = this.params.id;

        const filter = {
            is_activated: 'true',
            user_type: USER_TYPE.DOCTOR,
            company_id,
        }

        const projection = {
            'account_type': 1,
            'first_name': 1,
            'last_name': 1,
            'title': 1,
        }

        const companyUsersResponse: any = await this.userService.getUsers(filter, projection).toPromise();
        if (companyUsersResponse.status === 200) {
            this.providers = companyUsersResponse.data.map(p => Object.assign(p, {
                full_name: p.account_type === 'company' ?
                    `${p.first_name} ${p.last_name}, ${p.title} (company owner)` :
                    `${p.first_name} ${p.last_name}, ${p.title}`
            }));
        }
    }

    applyFilter(filterValue: string) {
        let filter = filterValue.trim().toLowerCase();
        if (filter) {
            let filterVal = [];
            this.facilities.forEach(facility => {
                if (facility.title.trim().toLowerCase().includes(filter)) {
                    filterVal.push(facility)
                    this.dataSource = new MatTableDataSource(filterVal);
                }
            });
        } else {
            this.dataSource = this.facilities;
        }
    }

    // biller-provider
    onProviderSelect(provider, facility) {
        // this.updateFacilityProviders(facility);
    }

    onSelectAllProvider(facility) {
        let isRelationCreating : boolean = true;
        this.updateFacilityProviders(facility,isRelationCreating);
    }

    onDeSelectAllProvider(facility) {
        let isRelationCreating : boolean = false;
        this.updateFacilityProviders(facility,isRelationCreating);
    }

    onProviderDeSelect(provider, facility) {
        // this.updateFacilityProviders(facility);
    }

    updateFacilityProviders(facility,isRelationCreating) {
        const { providersDropDown } = facility;
        return this.facilityService.updateFacilityProviders(facility._id, providersDropDown,isRelationCreating).subscribe((response: any) => {
            if (response.status == 200) {
                this.toastr.success("Relationship Updated")
            }
        })   
    }
    
    async onTemplateSelect(template, facility) {
        const company_id = this.params.id;
        // let result = await this.companyService.getCompanyName(company_id).toPromise();
        // if (result.status === 200) {
        //     let companyType = result.data.company_type.toLowerCase();
        //     if (companyType != 'wound') {
        //         if (facility.trueRCMID == '' || !facility.trueRCMID) {
        //             swal("No Unique ID", "Enter unique facility ID under settings!", "warning");
        //         }
        //     }
        // }
        let providers = facility.provider_ids_ref.map(a => a._id);
        let templates = facility.template_ids_ref.map(a => a._id);
        this.updateFacilityProviderTempalteAssoc(facility._id, providers, templates)
    }
    onTemplateDeSelect(template, facility) {
        if (template.full_name) {
            let provider = template;
            let providers = facility.provider_ids_ref.map(a => a._id)
            let templates = facility.template_ids_ref.map(a => a._id)
            this.updateFacilityProviderTempalteAssoc(facility._id, providers, templates, null, provider._id)
        }else{
            let providers = facility.provider_ids_ref.map(a => a._id)
            let templates = facility.template_ids_ref.map(a => a._id)
            this.updateFacilityProviderTempalteAssoc(facility._id, providers, templates,template._id, null)
        }
    }
    onSelectAllTemplate(facility) {
        let isRelationCreating : boolean = true;
        this.updateFacilityTemplates(facility,isRelationCreating)
    }

    onDeSelectAllTemplate(facility) {
        let isRelationCreating : boolean = false;
        this.updateFacilityTemplates(facility,isRelationCreating)
    }

    updateFacilityTemplates(facility, isRelationCreating) {
        const { allTemp } = facility;
        return this.facilityService.updateFacilityTemplates(facility._id, allTemp.map(p => p._id),isRelationCreating).toPromise();
    }
    async updateFacilityProviderTempalteAssoc(facility, providers, templates, template_id?, provider_id?) {
        let uniqueproviders = providers.filter((element, index) => {
            return providers.indexOf(element) === index;
        });
        this.facilityService.updateFacilityProviderTempalteAssoc(facility, uniqueproviders, templates, template_id, provider_id).subscribe((response: any) => {
            if (response.status == 200) {
                this.toastr.success("Relationship Updated")
            }
        })
    }
    // async goToPreviousPage() {
    //     if (this.pagination.pageNo > 1) {
    //         this.pagination.pageNo = this.pagination.pageNo - 1;
    //         this.pagination.currentRecords = (this.pagination.pageNo - 1) * this.PAGE_LIMIT + this.facilities.length;
    //         await this.initAssociationData();
    //     }
    //     if (this.pagination.pageNo === 1) {
    //         this.pagination.hasPrevPage = false;
    //     }
    //     this.pagination.hasNextPage = true;
    // }

    // async goToNextPage() {
    //     this.pagination.pageNo = this.pagination.pageNo + 1;
    //     this.pagination.currentRecords = (this.pagination.pageNo - 1) * this.PAGE_LIMIT + this.facilities.length;
    //     if (this.pagination.currentRecords > this.pagination.totalFacilities) {  //Page count should not exceed total limit
    //         this.pagination.currentRecords = this.pagination.currentRecords - (this.pagination.currentRecords - this.pagination.totalFacilities);
    //     }
    //     if (this.pagination.currentRecords === this.pagination.totalFacilities) {
    //         this.pagination.hasNextPage = false;
    //     }
    //     await this.initAssociationData();
    //     this.pagination.hasPrevPage = true;
    // }

    goToPreviousPage() {
        this.pagination.pageNo--;
        this.initAssociationData();
    }
    goToNextPage() {
        this.pagination.pageNo++;
        this.initAssociationData();
    }
}
